import { sortBy } from "ramda";
export default (xs) => sortBy(() => Math.random() > 0.5, xs);
//# sourceMappingURL=shuffle.mjs.map